<script lang="ts">
import { onMount } from "svelte";

import Button from "../../materialize/components/Button.svelte";
import FloatingActionButton from "../../materialize/components/FloatingActionButton.svelte";
import Icon from "../../materialize/components/Icon.svelte";
import ModalWindow from "../../materialize/components/ModalWindow.svelte";
import WordSearchForm from "./WordSearchForm.svelte";
let modal;
let searchform;
export let class_list: string[];

</script>
<ModalWindow title="Cerca parola" bind:this="{modal}">
    <WordSearchForm bind:this={searchform} on:submit={ ()=>{console.log("ABC");modal.close();} }></WordSearchForm>
</ModalWindow>
<FloatingActionButton class_list={class_list} side="right" on:click="{ ()=>{modal.open()}}">
</FloatingActionButton>